import { TOPIKSection } from './types';
import type { SectionIntro } from '../../sectionIntro';

export type { SectionIntro };

/**
 * TOPIK 听力理解介绍
 */
const TOPIK_LISTENING_INTRO: SectionIntro = {
  sectionId: TOPIKSection.LISTENING,
  title: '听力 (듣기)',
  description:
    'TOPIK II 听力部分共 50 题，测试您在各种情境下对韩语口语的理解能力。内容涵盖日常对话、新闻广播、演讲、讨论等多种场景，每段录音播放一到两遍，全部为 4 选 1 选择题。',
  duration: 60,
  tips: [
    '在音频播放前，先快速浏览题目和选项，预测听力内容',
    '注意对话中人物的关系、场合和语气，有助于判断正确答案',
    '听清数字、时间、地点等细节信息',
    '注意转折词（하지만, 그러나, 그런데）后面的内容往往是重点',
    '后半部分题目材料较长，注意把握文章的整体结构和中心思想',
    '如果错过某题，不要纠结，立即专注于下一题',
  ],
};

/**
 * TOPIK 阅读理解介绍
 */
const TOPIK_READING_INTRO: SectionIntro = {
  sectionId: TOPIKSection.READING,
  title: '阅读 (읽기)',
  description:
    'TOPIK II 阅读部分共 50 题，测试您的韩语书面理解能力。材料类型多样，包括广告、公告、说明文、新闻报道、评论和散文等，题目从词汇语法逐步过渡到长篇阅读理解，全部为 4 选 1 选择题。',
  duration: 70,
  tips: [
    '前半部分题目较简单，应快速作答，为后面的长篇阅读留出时间',
    '先看题目再读文章，明确需要查找的信息',
    '注意连接词和指示词，把握文章的逻辑关系',
    '中心思想题要关注首尾段落',
    '填入恰当的词汇或句子时，注意上下文的连贯性',
    '合理分配时间，50 题 70 分钟，平均每题约 1 分 20 秒',
  ],
};

/**
 * TOPIK 写作介绍
 */
const TOPIK_WRITING_INTRO: SectionIntro = {
  sectionId: TOPIKSection.WRITING,
  title: '写作 (쓰기)',
  description:
    'TOPIK II 写作部分共 4 题（51-54 题），测试您的韩语书面表达能力。51-52 题为完成句子/短文写作，53 题为根据图表资料撰写 200-300 字说明文，54 题为就指定话题撰写 600-700 字议论文。',
  duration: 50,
  tips: [
    '51-52 题注意使用与上下文一致的语法和表达，确保语句通顺',
    '53 题要涵盖图表中的所有关键信息，使用客观、书面化的表达',
    '54 题要有明确的观点和充分的论证，注意段落结构：开头、主体、结尾',
    '注意使用正确的终结词尾和书面语体（-는다/-습니다）',
    '合理分配时间：建议 51-52 题约 10 分钟，53 题约 15 分钟，54 题约 25 分钟',
    '写作完成后留出时间检查拼写、隔写和语法错误',
  ],
};

/**
 * TOPIK Section 介绍文案映射
 */
export const TOPIK_SECTION_INTROS: Record<string, SectionIntro> = {
  [TOPIKSection.LISTENING]: TOPIK_LISTENING_INTRO,
  [TOPIKSection.READING]: TOPIK_READING_INTRO,
  [TOPIKSection.WRITING]: TOPIK_WRITING_INTRO,
};

/**
 * 获取 TOPIK Section 介绍文案
 */
export function getTOPIKSectionIntro(sectionId: string): SectionIntro | null {
  return TOPIK_SECTION_INTROS[sectionId] || null;
}
